import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import { Edit2, Calendar, Newspaper } from 'lucide-react';
import './admin_member_list.css'; // Reusing your admin dashboard style architecture

const AdminContentManage = ({ type = 'event' }) => {
  const navigate = useNavigate();
  const isEvent = type === 'event';
  const collectionName = isEvent ? 'parmEvent' : 'parmNews';
  const prefix = isEvent ? 'event' : 'news';

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { 
    const fetchContent = async () => {
      try {
        // Query sorted by latest created index tracking parameters
        const q = query(collection(db, collectionName), orderBy('createdAt', 'desc'));
        const querySnapshot = await getDocs(q);
        const fetched = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setItems(fetched);
      } catch (err) {
        console.error("Failed to load content management grid lines:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, [collectionName]);

  return (
    <div className="admin-member-page">
      <div className="admin-member-container">
        <header className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2>Manage {isEvent ? 'Events' : 'News Articles'}</h2>
            <p>Review publishing records, edit active structural drafts, or update live feeds.</p>
          </div>
          <button className="act-btn btn-save" onClick={() => navigate(`/admin-parm/content-dashboard-parm/${prefix}`)}>
            + Add New
          </button>
        </header>

        {loading ? (
          <div className="admin-loader">Loading repository logs...</div>
        ) : (
          <div className="table-responsive-wrapper">
            <table className="member-data-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Title</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th style={{ textAlign: 'center' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.id}>
                    <td className="text-bold">{item[prefix + '_id']}</td>
                    <td>{item[prefix + '_title']}</td>
                    <td>{item.category || 'N/A'}</td>
                    <td>
                      {/* Dynamic status chip styling badges */}
                      <span className={`status-badge-chip ${item.status}`}>
                        {item.status === 'published' ? 'Live' : 'Draft'}
                      </span>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <div className="table-action-buttons" style={{ justifyContent: 'center' }}>
                        <button 
                          className="act-btn btn-edit"
                          onClick={() => navigate(`/admin-parm/content-dashboard-parm/${prefix}/${item.id}`)}
                          title="Edit Document Payload"
                        >
                          <Edit2 size={14} /> Edit
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminContentManage;